
import React, { useState } from 'react';
import { motion } from 'framer-motion';

export const ButterflyAndLotus: React.FC = () => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div 
      className="relative h-32 w-32 mx-auto cursor-pointer"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {/* Glowing effect behind the lotus */}
      <motion.div 
        className="absolute -inset-4 rounded-full bg-gradient-to-r from-blue-500/30 via-cyan-400/30 to-teal-300/30 blur-md"
        animate={{ 
          scale: isHovering ? [1, 1.1, 1] : 1,
          opacity: isHovering ? [0.6, 0.9, 0.6] : 0.6
        }}
        transition={{ 
          duration: isHovering ? 1.5 : 0.3, 
          repeat: isHovering ? Infinity : 0,
          ease: "easeInOut" 
        }}
      />

      {/* Lotus flower */}
      <div className="lotus absolute inset-0 flex items-center justify-center">
        {/* Outer petals */}
        {[...Array(8)].map((_, i) => (
          <motion.div
            key={i}
            className="lotus-petal absolute w-10 h-10 bg-gradient-to-b from-cyan-300 to-cyan-500 rounded-full"
            style={{
              transformOrigin: 'center bottom',
              transform: `rotate(${i * 45}deg) translateY(-14px)`,
              opacity: 0.8,
              filter: 'drop-shadow(0 0 3px rgba(103, 232, 249, 0.5))'
            }}
            animate={{
              scale: isHovering ? [1, 1.05, 1] : 1,
              rotateX: isHovering ? [0, 5, 0] : 0
            }}
            transition={{
              duration: 2,
              repeat: isHovering ? Infinity : 0,
              delay: i * 0.1,
              ease: "easeInOut"
            }}
          />
        ))}
        
        {/* Inner petals */}
        {[...Array(8)].map((_, i) => (
          <motion.div
            key={i + 8}
            className="lotus-petal absolute w-8 h-8 bg-gradient-to-b from-blue-300 to-blue-500 rounded-full"
            style={{
              transformOrigin: 'center bottom',
              transform: `rotate(${i * 45 + 22.5}deg) translateY(-8px)`,
              opacity: 0.9,
              filter: 'drop-shadow(0 0 3px rgba(96, 165, 250, 0.5))'
            }}
            animate={{
              scale: isHovering ? [1, 1.1, 1] : 1,
              rotateX: isHovering ? [0, 10, 0] : 0
            }}
            transition={{
              duration: 2,
              repeat: isHovering ? Infinity : 0,
              delay: i * 0.1 + 0.5,
              ease: "easeInOut"
            }}
          />
        ))}
        
        {/* Center of the lotus */}
        <motion.div 
          className="absolute w-6 h-6 bg-gradient-to-r from-yellow-300 to-amber-400 rounded-full z-10"
          animate={{
            scale: isHovering ? [1, 1.1, 1] : 1,
            opacity: isHovering ? [0.9, 1, 0.9] : 0.9
          }}
          transition={{
            duration: 2,
            repeat: isHovering ? Infinity : 0,
            ease: "easeInOut"
          }}
          style={{
            filter: 'drop-shadow(0 0 5px rgba(251, 191, 36, 0.8))'
          }}
        />
      </div>

      {/* Butterfly */}
      <motion.div 
        className="butterfly absolute"
        style={{ top: '-15px', left: '60%' }}
        animate={isHovering ? {
          y: [0, -10, 0],
          x: [0, 5, 0],
          rotate: [0, 5, -5, 0]
        } : {}}
        transition={{
          duration: 3,
          repeat: isHovering ? Infinity : 0,
          ease: "easeInOut"
        }}
      >
        <motion.div 
          className="butterfly-wing left absolute w-7 h-8 bg-gradient-to-br from-pink-400 to-purple-500 rounded-full"
          style={{ 
            left: '-14px', 
            transformOrigin: 'right center',
            filter: 'drop-shadow(0 0 3px rgba(219, 39, 119, 0.6))'
          }}
          animate={isHovering ? {
            rotateY: [0, 50, 0]
          } : {}}
          transition={{
            duration: 0.8,
            repeat: isHovering ? Infinity : 0,
            ease: "easeInOut"
          }}
        />
        <motion.div 
          className="butterfly-body absolute w-1 h-8 bg-gradient-to-b from-purple-800 to-purple-900"
          style={{ 
            left: 0, 
            borderRadius: '1px',
            filter: 'drop-shadow(0 0 1px rgba(107, 33, 168, 0.8))'
          }}
        />
        <motion.div 
          className="butterfly-wing right absolute w-7 h-8 bg-gradient-to-bl from-pink-400 to-purple-500 rounded-full"
          style={{ 
            left: '1px', 
            transformOrigin: 'left center',
            filter: 'drop-shadow(0 0 3px rgba(219, 39, 119, 0.6))'
          }}
          animate={isHovering ? {
            rotateY: [0, -50, 0]
          } : {}}
          transition={{
            duration: 0.8,
            repeat: isHovering ? Infinity : 0,
            ease: "easeInOut"
          }}
        />
      </motion.div>
    </div>
  );
};
